import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Award, Coins, Zap } from 'lucide-react';

export default function GroupAwardModal({
  open, onClose, group, activities, selectedActivity, setSelectedActivity,
  note, setNote, submitting, onAward
}) {
  if (!group) return null;

  const activityData = activities.find(a => a.id === selectedActivity);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Award className="w-5 h-5 text-amber-500" />
            Otorgar Actividad: {group.name}
          </DialogTitle>
          <DialogDescription>
            Todos los miembros del grupo ({group.member_count}) recibirán los coins y XP de la actividad
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Actividad</Label>
            <Select value={selectedActivity} onValueChange={setSelectedActivity}>
              <SelectTrigger data-testid="select-group-activity">
                <SelectValue placeholder="Selecciona una actividad" />
              </SelectTrigger>
              <SelectContent>
                {activities.map(activity => (
                  <SelectItem key={activity.id} value={activity.id}>
                    <div className="flex items-center gap-2">
                      <span>{activity.title}</span>
                      <span className="text-amber-600">({activity.coin_value} coins)</span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          {activityData && (
            <div className="p-3 bg-amber-50 rounded-lg">
              <div className="flex items-center gap-4 mb-2">
                <div className="flex items-center gap-1 text-amber-600">
                  <Coins className="w-5 h-5" />
                  <span className="font-bold">{activityData.coin_value} Coins</span>
                </div>
                {(activityData.xp_value > 0 || activityData.xp_breakdown?.length > 0) && (
                  <div className="flex items-center gap-1 text-purple-600">
                    <Zap className="w-5 h-5" />
                    <span className="font-bold">
                      {activityData.xp_breakdown?.reduce((sum, x) => sum + x.xp, 0) || activityData.xp_value} XP
                    </span>
                  </div>
                )}
              </div>
              <p className="text-sm text-amber-700">
                x{group.member_count} miembros = <span className="font-bold">
                  {activityData.coin_value * (group.member_count || 0)} coins totales
                </span>
              </p>
            </div>
          )}
          
          <div className="space-y-2">
            <Label>Nota (opcional)</Label>
            <Input
              placeholder="Ej: Proyecto final completado"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button 
            onClick={onAward} 
            disabled={submitting || !selectedActivity}
            className="bg-amber-500 hover:bg-amber-600"
          >
            {submitting ? 'Otorgando...' : `Otorgar a ${group.member_count} miembros`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
